import React from 'react';
import {Layout, Icon} from 'antd';

import createHistory from 'history/createHashHistory'//导入路由跳转历史

import HelpBar from './HelpBar';//页面右上部的帮助等部分
import Son from './Router';//主体显示内容
import Nav from './Nav';//主体导航
import StateMent from './../Business/CompanyCenter/Statement/Statement';//主体导航
import CompormiseCorrection from './../Business/CompormiseListAlready/CompormiseListAlreadyCorrection/CompormiseCorrection';//主体导航
import CaseDetailsInfoView from './../Common/CaseDetailsInfoView';//登记单详情
import CompanyRecord from './../Business/CompanyAccord/CompanyRecord/CompanyRecord';//登记
import { Route, Switch } from 'react-router-dom';
import "./style.css"
const history = createHistory();
const {Header, Sider, Footer, Content} = Layout;//定义外层框架所用组件


//外部布局
class App extends React.Component {

    //初始状态
    state = {
        collapsed: false,
        hei: 400,
        userName:""
    };

    //菜单栏变化
    toggle = () => {
        this.setState({
            collapsed: !this.state.collapsed,
        });
    };

    //屏幕尺寸变化
    windowChangeSize() {
        let H = window.innerHeight - 80;
        let W = window.innerWidth;
        let _this = this;
        if (W <= 960) {
            _this.setState({
                collapsed: true
            })
        } else {
            _this.setState({
                collapsed: false
            })
        }
        this.setState({
            hei: H > 580 ? H : 580
        })
    }

    //组件加载完成前
    componentWillMount(){
        //history.push({ pathname: '/err',})
    }

    //组件加载完成后
    componentDidMount() {
        let _this = this;
        this.windowChangeSize()
        window.onresize = function () {
            _this.windowChangeSize()
        }
        this.setState({
            userName: JSON.parse(localStorage.getItem("userInfo")).userName
        })

    }

    //组件的渲染
    render() {
        return (
            <Layout>
                <Header className="C_header" style={{ minWidth:760 }}>
                    <div className="logo"></div>
                    <div className="HomeTitle">
                        <span>江苏市消费者权益保护中心</span>
                    </div>
                    <div className="HomeAction">
                        <HelpBar/>
                    </div>
                </Header>
                <Layout>
                   
                    <Content className="HomeContent" style={{ minHeight: this.state.hei }}>
                        <Switch>
                            <Route exact path="/New/Statement" component={StateMent} />
                            <Route exact path="/New/CompormiseCorrection" component={CompormiseCorrection} />
                            <Route exact path="/New/CaseDetailsInfoView" component={CaseDetailsInfoView} />
                            <Route exact path="/New/CompanyRecord" component={CompanyRecord} />
                        </Switch>
                        <Footer className="HomeFoot">
                            技术支持：江苏户传科技有限公司   联系电话：025-83720315
                        </Footer>
                    </Content>
                </Layout>
            </Layout>
        );
    }
}

export default App




// WEBPACK FOOTER //
// ./src/components/Content/Wrap/statement.js